export const getVerticalScrollbarWidthIfVisible = () => {
    if (typeof window === 'undefined') {
        return 0
    }

    const docElement = document.documentElement
    const hasVerticalScrollbar = docElement.scrollHeight > docElement.clientHeight

    if (!hasVerticalScrollbar) {
        return 0
    }

    return window.innerWidth - document.documentElement.clientWidth
}
